import request from '../utils/request';
const truckBrokerPlatForm = "/landTransportApi/driver/gateway/truckBrokerPlatForm";

// 查询订单
export async function selectTruckBrokerOrder(params){
  let url =  `${truckBrokerPlatForm}/selectTruckBrokerOrder`;
  return request(url,{
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body:{
      ...params,
    }
  });
}
// 司机接单
export async function confirmOrder(params) {
  let url = `${truckBrokerPlatForm}/confirmOrder`;
  return request(url, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: {
      ...params,
    },
  });
}
// 司机拒单
export async function refuseOrder(params) {
  let url = `${truckBrokerPlatForm}/refuseOrder`;
  return request(url, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json"
    },
    body: {
      ...params,
    },
  });
}


// WEBPACK FOOTER //
// ./src/services/order.js